const SETTINGS_KEY = "skitterbook-settings";

function loadAll(): Record<string, unknown> {
    const raw = localStorage.getItem(SETTINGS_KEY);
    return raw ? JSON.parse(raw) : {};
}

function saveAll(obj: Record<string, unknown>) {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(obj));
}

export function getSetting<T>(key: string, defaultValue: T): T {
    const all = loadAll();
    const value = all[key];
    return (value as T) ?? defaultValue;
}

export function setSetting<T>(key: string, value: T): void {
    const all = loadAll();
    all[key] = value;
    saveAll(all);
}
